import React from 'react';
import { CouponAssessment, AssessmentField } from '../../../../../types/generated.types';
import FieldWrapper from '../../../../../common/FieldWrapper';
import AutoResizeTextarea from '../../../../../common/AutoResizeTextarea';
import StarRating from './StarRating';
import LoadingSkeleton from './LoadingSkeleton';

interface LoadingCouponAssessmentProps {
  assessmentFields?: AssessmentField[];
  existingAssessment?: CouponAssessment | null;
}

const LoadingCouponAssessment: React.FC<LoadingCouponAssessmentProps> = ({
  assessmentFields,
  existingAssessment
}) => {

  const showAllFields = !assessmentFields || assessmentFields.length === 0;

  const showRatingSkeleton =
    showAllFields || assessmentFields.includes(AssessmentField.Rating);

  const showMotivationSkeleton =
    showAllFields || assessmentFields.includes(AssessmentField.Motivation);

  const showExpectedEffectSkeleton =
    showAllFields || assessmentFields.includes(AssessmentField.ExpectedEffect);

  const showProfitabilitySkeleton =
    showAllFields || assessmentFields.includes(AssessmentField.Profitability);

  const showTargetGroupAdaptationSkeleton =
    showAllFields || assessmentFields.includes(AssessmentField.TargetGroupAdaptation);

  return (
    <>
      {/* Rating */}
      <FieldWrapper name="rating" title="">
        <div className="flex star-rating-container">
          {showRatingSkeleton ? (
            <LoadingSkeleton width="120px" height="20px" />
          ) : (
            <>
              <StarRating rating={existingAssessment?.rating ?? 0} hideText />
              <input
                type="number"
                value={existingAssessment?.rating ?? ''}
                className="rating-input"
                readOnly
              />
              /5
            </>
          )}
        </div>
      </FieldWrapper>

      {/* Motivation */}
      <FieldWrapper name="motivation" title="" x2>
        {showMotivationSkeleton ? (
          <LoadingSkeleton width="100%" height="38px" />
        ) : (
          <input
            type="text"
            value={existingAssessment?.motivation || ''}
            readOnly
          />
        )}
      </FieldWrapper>

      <div className="assessment-columns flex gap-2 mt">

        {/* Expected Effect */}
        <FieldWrapper name="expectedEffect" title="FÖRVÄNTAD EFFEKT">
          {showExpectedEffectSkeleton ? (
            <>
              <LoadingSkeleton width="100%" height="80px" />
            </>
          ) : (
            <AutoResizeTextarea
              value={existingAssessment?.expectedEffect || ''}
              readOnly
              rows={3}
              onChange={() => { }}
              placeholder="AI-genererad bedömning, ofta låg - hög, smal - bred + kommentar"
            />
          )}
        </FieldWrapper>

        {/* Profitability */}
        <FieldWrapper name="profitability" title="LÖNSAMHET">
          {showProfitabilitySkeleton ? (
            <>
              <LoadingSkeleton width="100%" height="80px" />
            </>
          ) : (
            <AutoResizeTextarea
              value={existingAssessment?.profitability || ''}
              readOnly
              rows={3}
              onChange={() => { }}
              placeholder="AI-genererad bedömning, ofta låg - hög, smal - bred + kommentar"
            />
          )}
        </FieldWrapper>

        {/* Target Group Adaptation */}
        <FieldWrapper name="targetGroupAdaptation" title="MÅLGRUPPSANPASSNING">
          {showTargetGroupAdaptationSkeleton ? (
            <>
              <LoadingSkeleton width="100%" height="80px" />
            </>
          ) : (
            <AutoResizeTextarea
              value={existingAssessment?.targetGroupAdaptation || ''}
              readOnly
              rows={3}
              onChange={() => { }}
              placeholder="AI-genererad bedömning, ofta låg - hög, smal - bred + kommentar"
            />
          )}
        </FieldWrapper>

      </div>
    </>
  );
};

export default LoadingCouponAssessment;
